import fetch from './fetch'

// 项目管理
// 开标人
export const GetPersonnelBasicList = (data) => {
	return fetch('/api/EmployeeBasic/GetPersonnelBasicList', data, 'POST')
}
export const GetTechnicalDirectorList = (data) => {
	return fetch('/api/ProjectUserMakeUp/GetTechnicalDirectorList', data, 'POST')
}

// 报名确认
export const EditTenderBidding_state = (data) => {
	return fetch('/api/ProjectTender/EditTenderBidding_state', data, 'POST')
}

// 删除角色人员
export const DeleteUserRole = (data) => {
	return fetch('/api/User/DeleteUserRole', data, 'POST')
}



// 添加角色
export const AddRoleAndRoleUseCase = (data) => {
	return fetch('/api/RoleUseCase/AddRoleAndRoleUseCase', data, 'POST')
}
export const GetNewCurrentRoleUseCaseInfo = (data) => {
	return fetch('/api/UseCase/GetNewCurrentRoleUseCaseInfo', data, 'POST')
}
export const NewEditRoleAndRoleUseCase = (data) => {
	return fetch('/api/RoleUseCase/NewEditRoleAndRoleUseCase', data, 'POST')
}



// 编号验证
export const VerificationRepeatData = (data) => {
	return fetch('/api/PublicVerification/VerificationRepeatData', data, 'POST')
}

// 人员智能匹配
export const GetPersonSmartMatchInfo = (data) => {
	return fetch('/api/PersonSmartMatch/GetPersonSmartMatchInfo', data, 'POST')
}

// 获取地址
export const GetAddressNameByID = (data) => {
	return fetch('/api/Address/GetAddressNameByID', data, 'POST')
}

// 人员匹配
export const GetPersonCerInfoByMoreCondition = (data) => {
	return fetch('/api/PersonSmartMatch/GetPersonCerInfoByMoreCondition', data, 'POST')
}

// 获取验证码
export const SendSMSVerificationCode = (data) => {
	return fetch('/api/SMS/SendSMSVerificationCode', data, 'POST')
}

// 登录接口
export const UserLoginVerification = (data) => {
	return fetch('/api/User/UserLoginVerification', data, 'POST')
	// return fetch('/api/User/UserLogin', data, 'POST')
}

// 基本资料
export const GetCurrentUserDetail = (data) => {
	return fetch('/api/User/GetCurrentUserDetail', data, 'POST')
}

// 修改密码
export const CurrentUserEditPwd = (data) => {
	return fetch('/api/User/CurrentUserEditPwd', data, 'POST')
}

// 权限信息
export const GetAllRoleList = (data) => {
	return fetch('/api/Role/GetAllRoleList', data, 'POST')
}

// 用户信息列表
export const GetUserList = (data) => {
	return fetch('/api/User/GetUserList', data, 'POST')
}
export const GetCurrentUserSelectRole = (data) => {
	return fetch('/api/User/GetCurrentUserSelectRole', data, 'POST')
}
export const SetUserRole = (data) => {
	return fetch('/api/User/SetUserRole', data, 'POST')
}

// 添加用户
export const GetNoDistributionEmployee = (data) => {
	return fetch('/api/User/GetNoDistributionEmployee', data, 'POST')
}
export const AddUser = (data) => {
	return fetch('/api/User/AddUser', data, 'POST')
}
export const EditUser = (data) => {
	return fetch('/api/User/EditUser', data, 'POST')
}



// 用户管理
export const GetUserManageInfoList = (data) => {
	return fetch('/api/User/GetUserManageInfoList', data, 'POST')
}
export const DeleteUser = (data) => {
	return fetch('/api/User/DeleteUser', data, 'POST')
}
export const GetUserDetail = (data) => {
	return fetch('/api/User/GetUserDetail', data, 'POST')
}


// 查询用户信息
export const GetUserInfoList = (data) => {
	return fetch('/api/User/GetUserInfoList', data, 'POST')
}

// 角色信息
export const GetRoleList = (data) => {
	return fetch('/api/Role/GetRoleList', data, 'POST')
}
export const GetCurrentRoleSelectUser = (data) => {
	return fetch('/api/Role/GetCurrentRoleSelectUser', data, 'POST')
}

export const DeleteRole = (data) => {
	return fetch('/api/Role/DeleteRole', data, 'POST')
}

export const GetNewMenuUseCaseInfo = (data) => {
	return fetch('/api/UseCase/GetNewMenuUseCaseInfo', data, 'POST')
}
export const SetRoleUser = (data) => {
	return fetch('/api/Role/SetRoleUser', data, 'POST')
}




// 流程审批
export const GetWorkFlowProcessList = (data) => {
	return fetch('/api/WorkFlowProcess/GetWorkFlowProcessList', data, 'POST')
}
export const OpenOrCloseWorkFlowProcess = (data) => {
	return fetch('/api/WorkFlowProcess/OpenOrCloseWorkFlowProcess', data, 'POST')
}

// 部门管理
export const NewGetDepartmentTree = (data) => {
	return fetch('/api/Department/NewGetDepartmentTree', data, 'POST')
}
export const AddDepartment = (data) => {
	return fetch('/api/Department/AddDepartment', data, 'POST')
}
export const DeleteDepartment = (data) => {
	return fetch('/api/Department/DeleteDepartment', data, 'POST')
}
export const EditDepartment = (data) => {
	return fetch('/api/Department/EditDepartment', data, 'POST')
}
export const GetNoDeptEmployee = (data) => {
	return fetch('/api/Department/GetNoDeptEmployee', data, 'POST')
}
export const EditEmpDept = (data) => {
	return fetch('/api/Department/EditEmpDept', data, 'POST')
}





// WEBPACK FOOTER //
// ./src/js/urls_sxm.js